let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cfuA9")).then(() => parcelRequire('48x2v'));